var React = require('react');

function ImportExport (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0h24v24H0V0z","id":"a"})),React.createElement("clipPath",{"id":"b","key":1},React.createElement("use",{"overflow":"visible","xlinkHref":"#a"})),React.createElement("path",{"clipPath":"url(#b)","d":"M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z","key":2})]);
}

ImportExport.displayName = "ImportExport";

ImportExport.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = ImportExport;

ImportExport.default = ImportExport;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ImportExport.svg
// module id = 644
// module chunks = 168707334958949